import React from "react";
//import { Modal,ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import './Signup.css';
class Signup extends React.Component {
  render() {
    return <div>

  <div className="container ">

      <div className="text-center p-5">
            <a className="" href="/#"> <img src="/assets/images/logo/logo.jpg" alt="" title="" className="img-fluid mb-2 popup-img" /> </a><br/>
            <a className="" href="/#"> <img src="/assets/images/logo/logo-3.png" alt="" title="" className="img-fluid secondary-logo" /> </a><br/>
          
            <button type="button" className=" add-to-cart2 btnn mt-3" onClick={() => this.props.updateState('login')}>Log In</button>
            <br/>
            <button type="button" className="  btnn  btn-outline-green " onClick={() => this.props.handleRegister()}>Sign Up</button>      </div>

  </div>


    </div>
    }
}

export default Signup;
